<template>
  <el-dialog 
    :visible.sync="show" 
    :title="title" 
    width="600px" 
    @close="cancel"
    :close-on-click-modal="false"
  >
    <div class="model-el-group">
      <el-form ref="editor" label-width="110px" :rules="rules"  :model="form">
        <el-form-item label="难度：">
          <!-- <div>无</div> -->
          <el-select size="medium" :disabled="isDisabled" v-model="form.nquestionLevel" clearable style="width:400px;" placeholder="请选择试题难度" @change="getQuestionBankQueryNum">
            <el-option :value="item.value" :label="item.label" v-for="(item, index) in TEST_TYPE.DIFFICULTY" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="试题分类：" prop="nquestionCategory">
          <el-select size="medium" v-model="form.nquestionCategory" clearable style="width:400px;" placeholder="请选择试题分类" @clear="clearUniteThree" @change="getQuestionBankQueryNum">
            <el-option :value="item.value" :label="item.label" v-for="(item, index) in QUESTIONS_TYPE.CLASSIFY" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <template v-if="form.nquestionCategory == 3">
          <el-form-item label="二级产品：" prop="ntwoProductObj">
            <el-select size="medium" v-model="form.ntwoProductObj" value-key="key" style="width:400px;" clearable filterable placeholder="请选择二级产品" @change="getThreeProductList" @clear="clearProductList">
              <el-option :value="item" :key="item.value" :label="item.value" v-for="item in secondProductList"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="三级产品：" prop="nthreeProductObj">
            <el-select size="medium" v-model="form.nthreeProductObj" value-key="key" style="width:400px;" clearable filterable placeholder="请选择三级产品" @change="getQuestionBankCountByFpbId" @clear="clearProductList">
              <el-option :value="item" :key="item.value" :label="item.value" v-for="item in threeProductList"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="品牌：">
            <el-select size="medium" v-model="form.sbrandObj" value-key="key" style="width:400px;" clearable filterable placeholder="请选择品牌" @change="getQuestionBankCountByFpbId" @clear="clearProductList">
              <el-option :value="item" :key="item.key" :label="item.value" v-for="item in brandList"></el-option>
            </el-select>
          </el-form-item>
        </template>
        <el-form-item label="抽取：" prop="num">
            <div class="position">
                <el-input type="text" v-model.number="form.num" style="width: 400px;" placeholder="请输入题数量"></el-input>
                <span>/{{topicNumber}}</span>
            </div>
        </el-form-item>
        <el-form-item label="每题分数：" prop="score">
          <el-input type="text" v-model.number="form.score" style="width: 400px;" placeholder="请输入每题分数"></el-input>
        </el-form-item>
        <el-button type="primary" class="submit" @click="seveRandomData">保 存</el-button>
      </el-form>
    </div>
  </el-dialog>
</template>
<script>
import { TEST_TYPE, QUESTIONS_TYPE } from '@/config/const/common.js'
import { getThreeProductList } from '@/service/area'
import { mapState } from "vuex";
import {
    questionBankCountByFpbId,   //对应二级产品|三级产品|品牌下的对应题目数量查询
    questionBankQueryNum,       //随机组卷选择试题分类获取数量
} from "@/service/examination";
export default {
  data() {
    return {
      TEST_TYPE,
      QUESTIONS_TYPE,
      threeProductList: [],      //三级产品列表
      productLoading: false,
      isDisabled: false,
      form: {
        nquestionLevel: '', //0=无, 1=入门，2=中等，3=困难

        nquestionCategory: '',  //试题分类
        nquestionType: '',  //1=单选，2=多选，3=判断

        ntwoProductObj: null,
        nthreeProductObj: null,
        sbrandObj: null,

        // sfieldId: '',       //二级产品id
        // sfield: '',         //二级产品name
        // sproductId: '',     //三级产品id
        // sproduct: '',       //三级产品name
        // sbrandId: '',       //品牌id
        // sbrand: '',         //品牌name
        num: '',            //提数
        score: '',          //每题分数
      },
      topicNumber: '',      //题数量
      rules: {
          // 考试类别
          nquestionCategory: [
            { required: true, message: '请选择考试类别', trigger: 'change' },
          ],
          num:[
            { required: true, message: '请输入题数量', trigger: 'blur' },
          ],
          score:[
            { required: true, message: '请输入每题分数', trigger: 'blur' },
          ],
          ntwoProductObj:[
            { required: true, message: '请选择二级产品', trigger: 'change' },
          ]
        },
      


      oraginForm:{},
      show: false,
      title: '',
    }
  },
  computed: {
    ...mapState({
      secondProductList: state => state.area.secondProductList,
      brandList: state => state.area.brandList
    })
  },
  watch:{
    'form.num':{
      handler(val) {
        if(val === 0) {
          alert(val)
          this.form.num = ''
          return this.$message.warning('抽取的数量不能为0')
        }
        if(val>this.topicNumber && this.topicNumber !== '') {
          this.form.num = ''
          return this.$message.warning('抽取的数量不可大于当前试卷库数量')
        }
      },
      immediate: false
    }
  },
  created(){
    this.oraginForm = JSON.parse(JSON.stringify(this.form))
  },
  methods: {
    clearUniteThree(){
      this.form.ntwoProductObj = null
      this.form.nthreeProductObj = null
      this.form.sbrandObj = null
    },
    // 获取三级产品
    getThreeProductList(){
      this.form.nthreeProductObj = null
      this.getProductListNoChange(this.form.ntwoProductObj.key)
    },

    async getProductListNoChange(id, nthreeProductObj = null){
      this.productLoading = true
      let res = await getThreeProductList({ParentId:id})
      this.productLoading = false
      res.Result == 1 ? this.threeProductList=res.Data: [];
      this.form.nthreeProductObj = nthreeProductObj;
      this.getQuestionBankCountByFpbId();
    },
    clearProductList() {
      this.getQuestionBankCountByFpbId();
    },
    async getQuestionBankCountByFpbId(){
      let data = Object.assign({}, this.form)
      !data.nquestionType && delete data.nquestionType
      data.nquestionLevel==='' && delete data.nquestionLevel
      if(data.nquestionCategory == 3) {
        if(data.ntwoProductObj) {
          data.ntwoProductId = data.ntwoProductObj.key
          data.ntwoProduct = data.ntwoProductObj.value
        }
        if(data.nthreeProductObj) {
          data.nthreeProductId = data.nthreeProductObj.key
          data.nthreeProduct = data.nthreeProductObj.value
        }
        if(data.sbrandObj) {
          data.sbrandId = data.sbrandObj.key
          data.sbrand = data.sbrandObj.value
        }
        data.twoProductName = data.ntwoProduct
        data.threeProductName = data.nthreeProduct
        delete data.ntwoProductObj
        delete data.nthreeProductObj
      }else {
        delete data.ntwoProductObj
        delete data.nthreeProductObj
        delete data.ntwoProductId,
        delete data.ntwoProduct,
        delete data.nthreeProductId,
        delete data.nthreeProduct,
        delete data.sbrandObj
        delete data.sbrandId
        delete data.sbrand
      }
      !data.nquestionCategory && delete data.nquestionCategory
      // !data.sfieldId && delete data.sfieldId + ''
      // !data.sfield && delete data.sfield
      // !data.sproductId && delete data.sproductId + ''
      // !data.sproduct && delete data.sproduct
      // !data.sbrandId && delete data.sbrandId + ''
      // !data.sbrand && delete data.sbrand
      delete data.num
      delete data.score
      let res = await questionBankCountByFpbId(data)
      this.topicNumber = res.Data
    },
    async getQuestionBankQueryNum(){
      let data = Object.assign({}, this.form)
      !data.nquestionType && delete data.nquestionType
      data.nquestionLevel==='' && delete data.nquestionLevel
      if(data.nquestionCategory == 3) {
        if(data.ntwoProductObj) {
          data.ntwoProductId = data.ntwoProductObj.key
          data.ntwoProduct = data.ntwoProductObj.value
        }
        if(data.nthreeProductObj) {
          data.nthreeProductId = data.nthreeProductObj.key
          data.nthreeProduct = data.nthreeProductObj.value
        }
        if(data.sbrandObj) {
          data.sbrandId = data.sbrandObj.key
          data.sbrand = data.sbrandObj.value
        }
        data.twoProductName = data.ntwoProduct
        data.threeProductName = data.nthreeProduct
        delete data.ntwoProductObj
        delete data.nthreeProductObj
      }else {
        delete data.ntwoProductObj
        delete data.nthreeProductObj
        delete data.ntwoProductId,
        delete data.ntwoProduct,
        delete data.nthreeProductId,
        delete data.nthreeProduct,
        delete data.sbrandObj
        delete data.sbrandId
        delete data.sbrand
      }
      
      
      !data.nquestionCategory && delete data.nquestionCategory
      delete data.num
      delete data.score
      let res = await questionBankQueryNum(data)
      this.topicNumber = res.Data
    },
    open(type,is,res) {
      if(is==1) {
        this.isDisabled = true
        this.form.nquestionLevel = 0
      }else {
        this.isDisabled = false
        this.form.nquestionLevel = ''
      }
      this.show = true
      switch(type) {
        case 1:
          this.title = '添加-单选题'
          break;
        case 2:
          this.title = '添加-多选题'
          break;
        case 3:
          this.title = '添加-判断题'
          break;
      }
      this.form.nquestionType = type
      this.topicNumber = res.Data
    },
    cancel() {
      this.$refs.editor.resetFields();
      this.form = JSON.parse(JSON.stringify(this.oraginForm))
      this.show = false
    },
    // 保存
    seveRandomData(){
      this.$refs.editor.validate((valid) => {
          if (valid) {
            let data = Object.assign({}, this.form);
            if(!data.nquestionCategory) {
              return this.$message.warning('试题分类不能为空')
            }
            if(!data.num) {
              return this.$message.warning('提取数量不能为空')
            }
            if(data.num > this.topicNumber) {
              return this.$message.warning('抽取的数量不可大于当前试卷库数量')
            }
            if(!data.score) {
              return this.$message.warning('每题分数不能为空')
            }
            !data.nquestionType && delete data.nquestionType
            data.nquestionLevel==='' && delete data.nquestionLevel
            if(data.nquestionCategory == 3) {
              if(data.ntwoProductObj) {
                data.ntwoProductId = data.ntwoProductObj.key
                data.ntwoProduct = data.ntwoProductObj.value
              }
              if(data.nthreeProductObj) {
                data.nthreeProductId = data.nthreeProductObj.key
                data.nthreeProduct = data.nthreeProductObj.value
              }
              if(data.sbrandObj) {
                data.sbrandId = data.sbrandObj.key
                data.sbrand = data.sbrandObj.value
              }
              data.twoProductName = data.ntwoProduct
              data.threeProductName = data.nthreeProduct
              delete data.ntwoProductObj
              delete data.nthreeProductObj
            }else {
              delete data.ntwoProductObj
              delete data.nthreeProductObj
              delete data.ntwoProductId,
              delete data.ntwoProduct,
              delete data.nthreeProductId,
              delete data.nthreeProduct,
              delete data.sbrandObj
              delete data.sbrandId
              delete data.sbrand
            }
            !data.nquestionCategory && delete data.nquestionCategory
            !data.num && delete data.num
            !data.score && delete data.score
            this.$emit('seveRandomNextBtn', data);


          } else {
            console.log('error submit!!');
            return false;
          }
        });
    },
    editOpen(data,type,is) {
      if(is==1) {
        this.isDisabled = true
      }else {
        this.isDisabled = false
      }
      this.show = true
      switch(type) {
        case 1:
          this.title = '编辑-单选题'
          break;
        case 2:
          this.title = '编辑-多选题'
          break;
        case 3:
          this.title = '编辑-判断题'
          break;
      }
      this.form.nquestionType = data.nquestionType
      this.form.nquestionCategory = data.nquestionCategory
      this.form.nquestionLevel = data.nquestionLevel
      let objF = {},objP = {}, objB = {};
      objF['key'] = data.twoProductId
      objF['value'] = data.twoProductName
      this.form.ntwoProductObj = objF;
      objP['key'] = data.threeProductId
      objP['value'] = data.threeProductName
      this.getProductListNoChange(this.form.ntwoProductObj.key, objP)
      objB['key'] = data.sbrandId
      objB['value'] = data.sbrand
      this.form.sbrandObj = objB
      this.getQuestionBankCountByFpbId()

      
      this.form.score = data.score
      this.form.num = data.num
      
    }
  }
}
</script>

<style lang="scss">
.position {
    position: relative;
    width: 400px;
    .el-input__inner {
        padding-right: 60px;
    }
    span {
        position: absolute;
        right: 0;
        top: 0;
        line-height: 40px;
        font-size: 14px;
        color: #333333;
        padding: 0 10px;
    }
}
.model-el-group {
  .el-form-item {
    margin-bottom: 22px !important;
  }
}
</style>